var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-intro"},[_vm._t("default",function(){return [_vm._v("This is intro")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }